import React from "react"
import { Link } from "gatsby"

import Layout from '../../components/layout'
import Seo from '../../components/seo'

import '../css/article.css'
//import images
import ad1 from '../../images/pyramids/pyramids_alien_drawing1.png'
import ad2 from '../../images/pyramids/pyramids_alien_drawing2.png'
import ad3 from '../../images/pyramids/pyramids_alien_drawing3.png'
import chambers from '../../images/pyramids/pyramids_chambers.png'
import image from '../../images/pyramids/pyramids_image.png'
import orion from '../../images/pyramids/pyramids_orion.png'
import star from '../../images/pyramids/pyramids_star_shaft.png'

import robot from '../../images/robot.png'
import bat from '../../images/bat.png'

const IndexPage = () => {
 
  return  (
<Layout>
    <Seo 
    title="The hidden secrets of pyramids- PYRAMIDS|SKTUTS"
    description="Do you know the pyramids were built with the help of aliens and in the wall paintings of Egyptians many alien paintings were found.Lets see what the truth is"
    keywords="pyramids facts,pyramids facts for kids,facts about pyramids,facts about pyramids of Giza,mayan pyramid facts,pyramids facts ks2,pyramids facts egypt,pyramids facts ancient egypt,pyramids facts amazing,pyramids facts in hindi,pyramids facts wikipedia,pyramids facts giza,pyramids facts video,pyramids facts dimensions,pyramids facts softschools,factslides pyramids,facts about pyramids,mayan pyramids facts,aztec pyramids facts,sudan pyramids facts,pyramids mathematical facts,pyramids mysterious facts,nubian pyramids facts,egypt pyramids facts and pictures,pyramids in africa facts,pyramids of giza facts and history,facts about pyramids of giza,pyramids of giza architecture facts,facts about pyramids in hindi,facts about pyramids wikipedia,facts about pyramids in mexico,pyramids of giza amazing facts,facts about pyramids of giza in egypt,african pyramids facts,pyramids biomass facts,pyramids of babylon facts,bosnian pyramids facts,how were pyramids built facts,building pyramids facts,bent pyramids facts,biggest pyramids facts,pyramids crazy facts,pyramids creepy facts,children's facts about pyramids,pyramids curious facts,egyptian pyramids cool facts,egyptian pyramids construction facts,pyramids of giza cool facts,cairo pyramids facts,egyptian pyramids facts ducksters,pyramids of giza facts ducksters,define pyramids facts,pyramids of egypt facts videos,pyramids giza egypt facts,egyptian pyramids facts ks2,egyptian pyramids facts wikipedia,egypt pyramids facts in hindi,egyptian pyramids facts video,egyptian pyramids facts pdf,egypt pyramids facts ks2,egyptian pyramids facts in hindi,pyramids facts for ks2,egyptian pyramids fun facts,great pyramids fun facts,mayan pyramids fun facts,pyramids giza facts legends mysteries,pyramids of giza facts ks2,pyramids of giza facts history,pyramids of giza facts youtube,pyramids of giza facts wikipedia,egypt pyramids giza facts,pyramids of giza facts in hindi,population pyramids geography facts,guatemala pyramids facts,ancient egyptian pyramids giza facts,pyramids facts in egypt,giza pyramids interesting facts,great pyramids interesting facts,mayan pyramids interesting facts,population pyramids interesting facts,inca pyramids facts,pyramids of chichen itza facts,ancient egyptian pyramids interesting facts,pyramids of giza important facts,the great pyramids important facts,mayan pyramids facts ks2,egyptian pyramids facts ks1,ancient egyptian pyramids facts ks3,egyptian pyramids math facts,pyramids of meroe facts,pyramids of mexico facts,pyramids and mummies facts,pyramids facts of ancient egypt,facts pyramids of giza,facts pyramids of egypt,fun facts pyramids of giza,interesting facts pyramids of giza,olmec pyramids facts,facts on pyramids ks1,obscure pyramids facts,pyramids primary facts,pyramids population facts,pyramids and pharaohs facts,pyramids of giza quick facts,pyramids random facts,pyramids rare facts,pyramids strange facts,pyramids secret facts,pyramids scary facts,pyramids shape facts,egyptian pyramids scientific facts,pyramids and sphinx facts,egypt pyramids short facts,sudanese pyramids facts,step pyramids facts,pyramids of giza short facts,pyramids of the sun facts,pyramids of teotihuacan facts,pyramids and tombs facts,pyramids top ten facts,the pyramids facts,tikal pyramids facts,pyramids of giza tourism facts,pyramids unknown facts,pyramids of giza unknown facts,pyramids weird facts,pyramids with facts,egyptian pyramids facts worksheet,giza pyramids weird facts,egyptian pyramids facts youtube,"  
    />
    <header>
    <h1 className="header-h1">Mysteries in pyramids construction</h1>

    <div className="header-banner">
        <img src={image} alt="The Egyptian pyramids are ancient pyramid-shaped masonry structures located in Egypt. As of November 2008, sources cite either 118 or 138 as the number of identified Egyptian pyramids. Most were built as tombs for the country's pharaohs and their consorts during the Old and Middle Kingdom periods."/>
    </div>
   
    </header>
     
            <section className="content">
            <article>
                        <br/>
                        <h1>Pyramids Facts:Aliens involvement in construction of pyramids in Egypt</h1>
                        <p>
                            Hope all of you might have listen and known about pyramids well its time to find some awesoeme and Mysterious facts about the great pyramids and its construction.There are many pyramids available across the globe in many countries of which the Egypt are the most famous.They were constructed by the early egyptians as far as 4000 years ago and are still present intact.The construction and structure of these pyramids are fascinating.It is constructed such a way that the lower chamber of the pyramids has a constant temperature of 20 degree celsius even when the outside temperature is far as high as 50 degree celsius.In this post we will be discussing many facts like this about the mighty pyramids.
                        </p>
                        <br/>
                        <h2>Construction theories of Pyramids</h2>
                        <p>
                            Each pyramid is made of limestone blocks which are put on top of one another and carved out to the shape.Each block of limestone weighs from 2,000 Kgs to 70,000 kgs and each pyramid consists of atleast 23 lakhs such blocks,Yes 23 lakhs.Modern cranes nowadays,equipped with latest technologies, used for commercial purposes can maximum lift 20,000 kilos.Now you maybe wondering how did they manage to keep those heavy block on top of each other 4,000 years ago and made such an beautiful structure.Well no one knows about it but we will be discussing about some theories next.
                        </p>
                        <h4><a href="https://en.wikipedia.org/wiki/Orion_correlation_theory" rel="noopener noreferrer" target="_blank">The Orion Corelation Theory</a>
                        </h4>
                        <p>
                            According to a popular theory called as orion Corelation theory which states that the three middle stars of the famous orion constellation(Alnitak,Alnilam,Mintaka) aligns perfectly with the tips of the pyramids and have same allignment.<br/>Just check out here
                            <img src={orion}  alt="It states that there is a correlation between the location of the three largest pyramids of the Giza pyramid complex and Orion's Belt of the constellation Orion, and that this correlation was intended as such by the original builders of the Giza pyramid complex. The stars of Orion were associated with Osiris, the god of rebirth and afterlife by the ancient Egyptians.Depending on the version of the theory, additional pyramids can be included to complete the data of the Orion constellation, and the Nile river can be included to match with the Milky Way galaxy. The theory was first published in 1989 in Discussions in Egyptology, volume 13. It was the subject of a bestseller, The Orion Mystery, in 1994, as well as a BBC documentary, The Great Pyramid: Gateway to the Stars (February 1994), and appears in some new-age books."/>
                            <br/>
                            Some theorists believe that aliens from these three stars came down to earth and helped the egyptians to build these magnificient structures with the help of technologies the brought with them.<br/>
                            No one knows who build the pyramids, is it aliens or egyptians or both but surely there is some connection of the pyramids to the external stars
                        </p>
                        <h2>Tunnels in pyramids</h2>
                        <p>
                            The pyramids are itself a big mystery and the tunnels inside it make the things more complicated and mysterious.They have made tunnels almost everywhere inside the pyramids.Initially what people thought was it is constructed only for ventilation but slowly this theory was ruled out because a robot when sent inside with a camera noted that they were closed and a door like knob was present there so how come is it made for ventilation.These chambers sepatrated the pyramids into many chambers out of which 3 have been discovered the lower one called the Base chamber, the middle one the queens chamber and the topmost one the kings chamber. 
                            <br/>
                            <img src={chambers}   alt="There are three known chambers inside the Great Pyramid. The lowest chamber is cut into the bedrock upon which the pyramid was built and was unfinished. The so-called Queen's Chamber and King's Chamber are higher up within the pyramid structure."/>
                            <br/>
                            <p>If you enter the pyramids with any the two tunnels on the top you can explore the whole pyramids but the fact is that no one was able to discover it completely.It is to be noted that it is said discovered chambers not the total number of chambers.No one exactly how many chambers are there.</p>
                            <h4><a href="https://en.wikipedia.org/wiki/Star_shafts" target="_blank" rel="noopener noreferrer">Star Shaft theory</a></h4>
                            <p>
                                Another theory made by many theorists says that the tunnels were constructed such that when  the king's body was kept in the pyramids then their souls can go to these stars directly.Have a glance at this image.
                                <img   src={star} alt="Star shafts are narrow ducts leading out of ancient structures such as the Egyptian pyramids and Baalbek. The shafts start inside the Kings Chamber of the Great Pyramid of Giza, and exit at the same height. Alexandre M. Badawy suggested that the shafts pointed to Orion's Belt during the period of the construction of the Giza complex.[1] It is thought that these openings were perhaps air vents for mummies or built to point to certain stars at the date of the pyramids construction"/>
                                When remote controlled camera cars were sent inside the queens chamber it was found that it is closed and like it was constructed such that no one should be able to enter it.Many theorists still believe that there are many more chambers yet to be discovered.Once a small camera was drilled into the queens chamber but it got destroyed mysteriously and after that the government of Egypt stopped any further exploration of the pyramids and made it illegal.

                            </p>
                        </p>
                        <h2>Why was Pyramids built</h2>
                        <p>According to many theorists the pyramids were constructed to bury the mummies of the kings and queens .Mummies are the dead body of peoples wrapped in linen and kept in tombstones with their bodies dried completely.But do you know how many mummies were found in the pyramids? Shockingly the answer is zero.No king's tomb was found on king's chamber and no queen's tomb on queen's chamber.<br/>
                            Many theorists still believe that pyramids were constructed for an entirely different purpose and not for burying.Even some believe it was built for aliens to work and live in earth.
                        </p>
                        <h2>Locations of pyramids</h2>
                        <p>Do you know the locations of pyramids well ofcourse no but if calculate whole surface of earth and find its geographical center then you would get the position as the exact position of pyramids.Ofcourse this can be a co-incidence but just think 4,000 years ago when no one knew about geography even they didnt know that earth was round then how did the pyramids were constructed.</p>
                        <p>Another fact which may disturb you is that the north side of the pyramid is in exact alignment with the geographical north pole with just some few kilometers away which may be due to tectonic plate movements over the years otherwise it would be in perfectly aligned position.</p>

                        <h2>Pyramid stones</h2>
                        <p>
                            The stones used in pyramids were much harder and durable than the modern day stones.Many Scientists have taken the samples of these stones but none of them was able to find the exact specification of the stone.These stones are like limestone but not exactly lime stone.Also this type of stone is never found anywhere else in any part of earth.
                        </p>
                        <h2>Construction technologies</h2>
                        <p>The pyramids were constructed using the modern ball and socket method.This method is effective against the expansion and contaction due to sun's heat in the extreme temperature.This technology is also used nowadays for earthquake resistant buildings.Just imagine earthquake resistant buildings 4000 years ago</p>
                        <h3>Natural AC in basement</h3>
                        <p>Also the pyramids were constructed such that in the desert even when the temperature is 50 degree celsius the temperature of the basement of pyramid remains at a whooping constant of 20 degree celsius.It will same for the whole year both in day and night .Just think of the technology used there 4,000 years ago.</p>
                        <p>Do you think the facts like natural ACs,earthquake resistance,orion star alignment,north pole facing without compass is just a co-incidence or there were some mystical and powerful force behind it who had this great technology 4,000 years ago.
                        </p>
                        <h2>
                            Alien drawings in Pyramids of Egypt
                        </h2>
                        <p>
                            Drawings were an essential part of egyptians and they made drawing of almost all the things they do.One such drawing was found and was shocking.Just look at those drawings below
                            <img src={ad1}   alt="aliens drawing of helicopters and drones found in walls of pyramids that comfirm that helicopters existed that age ago and aliens brought it Awesome pyramids facts three"/>
                            <p>If you look closely this photo shows the depiction of aeroplanes and helicopters which were definetely not discovered at that time, then the question arises how did they managed to make that drawing.Was that those alien ships helping them out to build those pyramids.</p>
                            <img src={ad2}   alt="depiction of modern alien with big eyes and large head and small height who helped in construction of pyramids to egyptains awesome pyramids facts two"/>
                            <p>This second image depicts a modern day alien with huge face and eyes and small heights which clearly confirms it is an alien working with them.</p>
                            <img src={ad3}   alt="depiction of modern day UFOs found on a wall painting in pyramids Awesome pyramid facts one"/>
                            <p>This drawing also shows a depiction of an UFO maybe the one with which the aliens came to meet them</p>

                        </p>
                    
            </article>
            <div className="other">
                <div className="content1">
                  <Link to="/isro-aditya-l1/aditya-l1-isro-mission-to-conquer-the-sun">
                     <h4>
                        ISRO's mission to conquer the sun    
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/area-51/the-mystery-of-area-51-revealed">
                     <h4>
                        The mystery of area 51 revealed
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/amazon.com/unique-products-available-on-amazon">
                     <h4>
                        Unique products available on amazon.in
                      <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/cicada-3301/the-unsolved-mystery-of-cicada-3301">
                     <h4>
                        The unsolved mystery of cicada 3301
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="create-a-blog/an-indepth-guide-on-how-to-make-a-blog">
                     <h4>
                        How to create a free blog
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/truecaller-truth/truecaller-business-model-and -truth-revealed">
                     <h4>
                         The truth of truecaller app
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/devil-sea/the-mystery-of-devil-sea">
                     <h4>
                        The unsolved mystery of devil sea
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/time-travel/the-mystery-of-time-travel-revealed">
                     <h4>
                         The time travel mystery revealed
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/earn-money-online/ultimate-guide-to-earn-money-in-2019">
                     <h4>
                         Simple steps to earn money online
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/sun-facts/what-if-the-sun-disappears">
                     <h4>
                         What if the sun disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/fast-charger/fast-charging-technologies-explained">
                     <h4>
                        The principle of fast charging in smartphones
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/flat-earth/the-reality-of-flat-earth-society-debunked">
                     <h4>
                         The reality of flat earth society
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/smartphone-buying/ultimate-guide-to-purchase-smartphone">
                     <h4>
                         Ultimate guide to purchase a new smartphone
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/global-warming/innovative-technology-to-stop-global-warming">
                     <h4>
                        Innovation In Technologies to stop global warming
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/gps-working/indepth-guide-on-how-gps-works">
                     <h4>
                         Indepth guide on the working of GPS
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
           
            
            <div className="other">
                <div className="content1">
                  <Link to="/laptop-buying/ultimate-laptop-buying-guide">
                     <h4>
                         The ultimate laptop buying guide             
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/moon-facts/what-if-moon-disappears">
                     <h4>
                         What if the moon disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 

                
         
</section> 
</Layout>
)}

export default IndexPage
